// Default width that Copilot Chat Drawer would normally be in.
// Note that this is also the minimum width for the Drawer at the moment, as well.
export const DEFAULT_COPILOT_CHAT_DRAWER_WIDTH = 380;

// If the canvas is less than 775px, we enter a specific viewing mode where
// the Copilot Chat Drawer takes up the entire canvas width when opened.
export const NARROWEST_CANVAS_MODE_BREAKPOINT = 775;

// The maximum width that the drawer can be resized to (given enough room) is 60% of the canvas width.
export const MAX_COPILOT_CHAT_DRAWER_WIDTH_CANVAS_RATIO = 0.6;

// For the expand/collapse button, when the expand button is executed, we set the drawer
// to a % of the canvas width. Currently, that ratio is set to 50% of the canvas width.
export const EXPANDED_COPILOT_CHAT_DRAWER_WIDTH_CANVAS_RATIO = 0.5;
